import type { RenderContext } from "../../types/render";
import type { ResolvedTextEngine } from "./types";

export function selectTextEngine(ctx: RenderContext): ResolvedTextEngine {
  const requested = ctx.textEngine ?? "auto";

  if (requested === "auto") {
    if (ctx.printerProfile?.supportsTb === true) {
      return "tb";
    }
    return "line-safe";
  }

  return requested;
}
